<div class="bulk">
    <div class="lx-label">{{title}}</div>
    <div class="bulk__error">{{error}}</div>
    <textarea [(ngModel)]="inputText" id="inputText" type="text" [placeholder]="placeholder"></textarea>
    <div class="bulk__add">
        <span *ngIf="!loading" class="bulk__add__button" (click)="add()">+ Add</span>
        <span *ngIf="loading">Loading...</span>
    </div>
    <div *ngIf="entities?.length && !isDevice" class="bulk__accepted">
        <div class="bulk__accepted__internal" *ngFor="let entity of entities">
            <div>{{entity.id}}</div>
        </div>
    </div>

    <div *ngIf="entities?.length && isDevice" class="bulk__accepted">
        {{deviceDisplay}}
    </div>
</div>